import { Directive, ElementRef, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';

@Directive({
	selector: '[appConfirmButton]',
	standalone: true,
})
export class ConfirmButtonDirective {
	private readonly el = inject(ElementRef);

	@Input('appConfirmButton') confirmButtonFunction: () => any;
	@Input('appConfirmButtonOptions') confirmButtonOptions: {
		backgroundColor?: string;
		color?: string;
		confirmTimer?: number;
	} = {
		backgroundColor: null,
		color: 'var(--danger)',
		confirmTimer: 5000,
	};
	@Output() onConfirmButtonClick = new EventEmitter<void>();

	onConfirmationClick = false;
	elOriginalStyle: CSSStyleDeclaration;

	constructor() {
		this.elOriginalStyle = { ...this.el.nativeElement.style };
	}

	@HostListener('click', ['$event'])
	handleClick(event: Event) {
		event.stopPropagation();
		const htmlElement = this.el.nativeElement as HTMLElement;
		if (this.onConfirmationClick) {
			this.confirmButtonFunction?.();
			this.resetEl();
			this.onConfirmButtonClick.emit();
			this.onConfirmationClick = false;
		} else {
			if (this.confirmButtonOptions.backgroundColor) htmlElement.style.backgroundColor = this.confirmButtonOptions.backgroundColor;
			htmlElement.style.color = this.confirmButtonOptions.color ? this.confirmButtonOptions.color : 'var(--danger)';
			this.onConfirmationClick = true;
			setTimeout(() => {
				this.resetEl();
				this.onConfirmationClick = false;
			}, this.confirmButtonOptions.confirmTimer || 5000);
		}
	}

	resetEl() {
		const htmlElement = this.el.nativeElement as HTMLElement;
		htmlElement.style.backgroundColor = this.elOriginalStyle.backgroundColor;
		htmlElement.style.color = this.elOriginalStyle.color;
	}
}
